import {
  accordionStyles,
  accordionSummaryStyles,
  accordionDetailsStyles,
  alertStyles,
  appBarStyles,
  breadcrumbsStyles,
  buttonStyles,
  dialogTitleStyles,
  dividerStyles,
  formControlLabelStyles,
  iconButtonStyles,
  linearProgressStyles,
  menuItemStyles,
  paperStyles,
  radioStyles,
  selectStyles,
  textFieldStyles,
  chipStyles,
  tablePaginationStyles,
  tabsStyles,
  typographyStyles,
  inputLabelStyles,
  tabStyles
} from './components';

declare module '@mui/material/styles' {
  interface Palette {
    customGrey: {
      medium: string;
      light: string;
      dark: string;
    };
    aiColours: {
      green: string;
      orange: string;
    };
    aiGradient: string;
    white: string;
    // Change to success when fully migrated
    successV2: {
      main: string;
      light: string;
    };
    // Change to warning when fully migrated
    warningV2: {
      main: string;
      light: string;
      dark: string;
    };
    border: {
      large: {
        primary: {
          main: string;
        };
      };
      small: {
        grey: {
          medium: string;
          dark: string;
        };
        error: {
          main: string;
        };
        warning: {
          dark: string;
        };
      };
    };
    black: string;
    /**
     * @deprecated
     */
    success: Palette['success'];
    /**
     * @deprecated
     */
    tertiary: Palette['primary'];
    /**
     * @deprecated
     */
    default: string;
    /**
     * @deprecated
     */
    poppGrey: Palette['primary'];
    /**
     * @deprecated
     */
  }
  interface PaletteOptions {
    white: string;
    customGrey: {
      medium: string;
      light: string;
      dark: string;
    };
    aiColours: {
      green: string;
      orange: string;
    };
    aiGradient: string;
    // Change to success when fully migrated
    successV2: {
      main: string;
      light: string;
    };
    // Change to warning when fully migrated
    warningV2: {
      main: string;
      light: string;
      dark: string;
    };
    border: {
      large: {
        primary: {
          main: string;
        };
      };
      small: {
        grey: {
          medium: string;
          dark: string;
        };
        error: {
          main: string;
        };
        warning: {
          dark: string;
        };
      };
    };
    black: string;
    /**
     * @deprecated
     */
    tertiary: PaletteOptions['primary'];
    /**
     * @deprecated
     */
    default: string;
    /**
     * @deprecated
     */
    poppGrey: PaletteOptions['primary'];
    /**
     * @deprecated
     */
  }
}

/**
 * @deprecated
 */
export const themeColors = {
  primary: {
    main: '#A63DF1'
  },
  error: {
    main: '#DC262F'
  },
  text: {
    main: '#504955',
    secondary: '#8C8393'
  },
  grey: {
    dark: '#504955',
    light: '#8C8393'
  }
} as const;

export const themeConfig = {
  components: {
    MuiInputLabel: inputLabelStyles,
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingBottom: 0
        }
      }
    },
    MuiAccordion: accordionStyles,
    MuiAccordionSummary: accordionSummaryStyles,
    MuiAccordionDetails: accordionDetailsStyles,
    MuiAlert: alertStyles,
    MuiAppBar: appBarStyles,
    MuiBreadcrumbs: breadcrumbsStyles,
    MuiButton: buttonStyles,
    MuiChip: chipStyles,
    MuiDialogTitle: dialogTitleStyles,
    MuiDivider: dividerStyles,
    MuiFormControlLabel: formControlLabelStyles,
    MuiLinearProgress: linearProgressStyles,
    MuiMenuItem: menuItemStyles,
    MuiPaper: paperStyles,
    MuiRadio: radioStyles,
    MuiIconButton: iconButtonStyles,
    MuiSelect: selectStyles,
    MuiTablePagination: tablePaginationStyles,
    MuiTabs: tabsStyles,
    MuiTextField: textFieldStyles,
    MuiTypography: typographyStyles,
    MuiTab: tabStyles
  },
  typography: {
    fontFamily: 'Instrument Sans, Arial, sans-serif'
  }
};
